export const mapLeadDto = (dto) => ({
    id: dto.id,
    companyName: dto.company_name,
    contactPerson: dto.contact_person,
    phone: dto.phone,
    email: dto.email,
    city: dto.city,
    industry: dto.industry,
    website: dto.website,
    source: dto.source,
    status: dto.status,
    priority: dto.priority || 'Medium',
    notes: dto.notes,
    contactAttempts: dto.contact_attempts ?? 0,
    lastContactDate: dto.last_contact_date,
    nextFollowUpDate: dto.next_follow_up_date,
    ownerUserId: dto.owner_user_id,
    ownerName: dto.owner_name,
    convertedAcquisitionId: dto.converted_acquisition_id,
    createdAt: dto.created_at,
    updatedAt: dto.updated_at,
});

const orNull = (value) => (value === '' || value === undefined ? null : value);

/** Frontend shape → API payload (snake_case). */
export const toLeadPayload = (lead) => ({
    company_name: lead.companyName,
    contact_person: orNull(lead.contactPerson),
    phone: orNull(lead.phone),
    email: orNull(lead.email),
    city: orNull(lead.city),
    industry: orNull(lead.industry),
    website: orNull(lead.website),
    source: orNull(lead.source),
    priority: lead.priority || 'Medium',
    notes: orNull(lead.notes),
    next_follow_up_date: orNull(lead.nextFollowUpDate),
});
